import React, { Component } from 'react';
import { Grid, Typography, Button, withStyles, CircularProgress } from '@material-ui/core';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { resetPassword, verifyResetPasswordToken } from '../../actions/accountActions';
import TextBox from '../../components/TextBox/TextBox.jsx';
import Slider from '../../components/Slider/Slider.jsx';
import AccountStyles from './AccountStyles.jsx';
import Styles from '../../layouts/Styles.jsx';
import Logo from '../../assets/images/logo.png';


class ResetPassword extends Component {
	/**
	 * Constructor
	 * @description Class Constructor
	 * @param {object} props
	 */
    constructor(props) {
        super(props);
        this.state = {
            "password": '',
            "confirm_password": '',
            "token": ''
        };

        //Validate Password match validation
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
            if (value !== this.state.password) {
                return false;
            }
            return true;
        });
    }

    /**
     * ComponentDidMount
     * @description Update the state userid property to encoded userid
     */
    componentDidMount() {
        this.setState({ token: this.props.match.params.token });
        this.verifyToken();
    }

    verifyToken() {
        this.props.verifyResetPasswordToken(this.props.match.params.token);
    }

	/**
	 * HandleChange
	 * @description Update input value to state variable
	 * @param {string} name Input name
	 * @param {object} event Input field event
	 */
    handleChange = (name) => (event) => {
        this.setState({ [name]: event.target.value });
    }


    /**
     * HandleSubmit
     * @description Activate user
     */
    handleSubmit = () => {
        const model = Object.assign({}, this.state);
        delete model.confirm_password;
        this.props.resetPassword(model);
    }

    render() {
        const { classes, isLoading, theme } = this.props;
        return (
            <Grid container className={classes.container}>
                <Grid item xs={8} className={classes.sliderContainer}>
                    <Slider />
                </Grid>
                <Grid item xs={4} className={classes.container}>
                    <Grid container direction="column" justifyContent="space-between" className={classes.section} wrap="nowrap">
                        <Grid item align="center">
                            <img src={Logo} alt="Logo" className={classes.logo} />
                        </Grid>
                        <Grid item>
                            <ValidatorForm name="resetpasswordform" onSubmit={() => this.handleSubmit()}>
                                <Typography variant="h3" className={classes.accountTitleLogin}>
                                    {'Reset Password'}
                                </Typography>
                                <TextBox
                                    label="Password"
                                    type="password"
                                    onChange={this.handleChange('password')}
                                    name="password"
                                    validators={['required']}
                                    errorMessages={['Password is required']}
                                    id="password"
                                    value={this.state.password}
                                    fullWidth
                                    margin="normal"
                                    autoComplete="off"
                                />
                                <TextBox
                                    label="Confirm Password"
                                    type="password"
                                    onChange={this.handleChange('confirm_password')}
                                    name="confirm_password"
                                    validators={['required', 'isPasswordMatch']}
                                    errorMessages={['Confirm Password is required', 'Password not match']}
                                    id="confirm_password"
                                    value={this.state.confirm_password}
                                    fullWidth
                                    margin="normal"
                                    autoComplete="off"
                                />
                                <Grid container direction="row" justifyContent="space-between" className={classes.btnContainer}>
                                    <Grid item>
                                        <Button variant="contained"
                                            type="submit"
                                            size="large"
                                            color="primary"
                                            className={classes.loginbtn}
                                            disabled={isLoading}>

                                            {
                                                isLoading ?
                                                    <CircularProgress className={classes.progress}
                                                        color="primary"
                                                        size={24}
                                                        thickness={4} /> : `Reset Password`
                                            }
                                        </Button>
                                    </Grid>
                                    <Grid item align="right">
                                        <Button disabled={isLoading}
                                            className={classNames(classes.block, classes.nopadding, classes.inlineButton, classes.Linkhover)}
                                            onClick={() => this.props.history.push('/')}>
                                            Already have an account?
                                        </Button>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        </Grid>
                        <Grid item align="center">
                            <Typography variant="body2" className={classes.copyrightText}>
                                {theme.palette.loginCopyrightText}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

ResetPassword.propTypes = {
    classes: PropTypes.object,
    isLoading: PropTypes.bool,
    theme: PropTypes.object,
    verifyResetPasswordToken: PropTypes.func,
    resetPassword: PropTypes.func,
    history: PropTypes.object,
    match: PropTypes.object
};

/**
 * Map State To Props
 * @description Get Reducer Props value to Props property
 * @param {object} account
 */
const mapStateToProps = ({ account }) => {
    return {
        ...account
    };
};

/**
 * Dispatch Props
 * @description dispatch Props actions
 * @param {object} dispatch
 */
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ resetPassword, verifyResetPasswordToken }, dispatch);

};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles((theme) => ({
    ...AccountStyles(theme),
    ...Styles(theme)
}), { withTheme: true })(ResetPassword));